import { CSSProperties } from "react";

export const ReferralManagementBox = () => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minHeight: "75vh",
  maxHeight: "75vh",
  overflow: "hidden",
  border: "none",
});

export const DinaImageBox = () => ({
  position: "relative",
  height: "100%",
  width: "100%",
});

export const DinaImageStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};
